<kf-menu tabindex="0">
  <div class="menu { props.open ? 'menu-show' : 'menu-hide' }">
    <slot />
  </div>
  <script>
    const contains = (el, target) => el && Array.from(el.querySelectorAll('*')).includes(target);

    export default {
      anchorEl: null,
      style: {},
      onBeforeMount() {
        this.style = {};
        if (this.props.maxHeight != null) {
          this.style['max-height'] = this.props.maxHeight + 'px';
        }

        if (this.props.width != null) {
          this.style.width = this.props.width + 'px';
        }
      },

      documentClick(e) {
        if (e.target == this.root || this.anchorEl == e.target || contains(this.root, e.target) || contains(this.anchorEl, e.target)) {
          return;
        }
        this.props.onClose();
      },

      onMounted() {
        document.addEventListener('click', this.documentClick, { passive: true });
        const menu = this.$('.menu');
        menu?.setAttribute('style', this.$css(this.style));
      },

      onUnmounted() {
        document.removeEventListener('click', this.documentClick);
      },

      onBeforeUpdate() {
        const inputHeight = this.props.inputHeight || 32;
        if (this.props.anchorEl && this.anchorEl == null) {
          const el = this.props.anchorEl;
          const rect = el.getBoundingClientRect();
          const menu = this.$('.menu');
          const height = menu.clientHeight;
          menu.style.left = '-1000px';
          menu.style.top = '-1000px';
          const width = menu.clientWidth;
          const diffX = window.innerWidth - rect.x;
          const diffY = window.innerHeight - rect.y;
          if (this.props.type == 'nav') {
            this.style.top = '';
            this.style['transform-origin'] = 'top';
          } else if (diffY < height) {
            this.style.top = Math.max(46, rect.y - height) + 'px';
            if (rect.y - height < 0) {
              this.style['transform-origin'] = 'center';
            } else {
              this.style['transform-origin'] = 'bottom';
            }
          } else {
            this.style.top = rect.y + inputHeight + 'px';
            this.style['transform-origin'] = 'top';
          }
          this.style.position = 'fixed';
          if (diffX < width && !this.props.width) {
            this.style.left = rect.x - (width - diffX) - 8 + 'px';
          } else {
            const left = this.props.width ? rect.x - (this.props.width - el.clientWidth) : rect.x;
            this.style.left = left + 'px';
          }
          if (this.props.maxHeight != null && this.props.maxHeight <= height) {
            this.style.transform = 'none';
            this.style['transition-property'] = 'opacity';
          }
          this.root.focus();
        }
        this.anchorEl = this.props.anchorEl;
        if (this.props.maxHeight != null) {
          this.style['max-height'] = this.props.maxHeight + 'px';
        }

        if (this.props.width != null) {
          this.style.width = this.props.width + 'px';
        }
      },

      onUpdated() {
        const menu = this.$('.menu');
        menu?.setAttribute('style', this.$css(this.style));
      },
    };
  </script>
  <style>
    .menu {
      position: fixed;
      overflow: auto;
    }
  </style>
</kf-menu>